declare let process: any;

const isProd = 'production' === process.env.NODE_ENV;
export const environment: RmEnvironment = {
    production: isProd
};

if (!environment.production) {
    console.log('Current environment: ', environment);
}


interface RmEnvironment {
    production: boolean;
}


// WEBPACK FOOTER //
// ../inline/src/modules/shared/environment.ts